import { render } from "./FacultyTaggedDialog.vue?vue&type=template&id=6547dc54"
import script from "./FacultyTaggedDialog.vue?vue&type=script&lang=js"
export * from "./FacultyTaggedDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__